<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/dateintervals/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Dátum</h1>
          <div class="row">
            <div class="col-xs-6">
              <div class="row">
                <div class="col-xs-12">
                  <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
                </div>
                <div class="col-xs-6">
                  <inputbox :datepicker="{enableTime: false}" id="start_date" label="Dátum-tól" v-bind:errors="errors" name="start_date" v-model="form.start_date"></inputbox>
                </div>
                <div class="col-xs-6">
                  <inputbox :datepicker="{enableTime: false}" id="end_date" label="Dátum-ig" v-bind:errors="errors" name="end_date" v-model="form.end_date"></inputbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        name: '',
        start_date: '',
        end_date: ''
      },

      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('date_intervals/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.dateID != undefined ? _this.$route.query.dateID : 0), {
        success: function(response) {
          _this.form = response.date_interval;
        }
      });
    });
  },

  methods: {
    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('date_intervals/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/dateintervals'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// dateinterval.vue?771d8dca